export * from './WarningTriangleFilled';
